export const LOGOUT = "LOGOUT";
export const LOGOUT_REQUESTED = "LOGOUT_REQUESTED";

export const CLEAN_LOGIN_DATA = "CLEAN_LOGIN_DATA";

export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const REFRESH_TOKEN_REQUESTED = "REFRESH_TOKEN_REQUESTED";
